(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-paginate"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-trustpilot-home-before-20261013-final"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadWidgets = (root) => {
      if (typeof window.Trustpilot?.loadFromElement !== 'function') return;
      root.querySelectorAll('.ss-home-trustpilot .trustpilot-widget').forEach((widget) => {
        if (!widget.querySelector('iframe')) window.Trustpilot.loadFromElement(widget);
      });
    };
    loadWidgets(document);
    document.addEventListener('shopify:section:load', (event) => loadWidgets(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
